import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Input } from '../../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../shared/http-client';
import { FormFooter } from '../../../elements/form-footer';
import { FieldError } from '../../../elements/field-error/field-error';
import { TextArea } from '../../../elements/text-area';
import dayjs from 'dayjs';
import { Select } from '../../../elements/select';
import { RadioGroup } from '../../../elements/radio-group';


// construccion del objeto yup de validacion del cuestionario
let obligado = {
    address: Yup.string().required('obligatorio'),
    country: Yup.mixed().required('obligatorio'),
    city: Yup.mixed().required('obligatorio'),
};
const validacion = Yup.object().shape(obligado);

const initialValues: any = {
    address: '',
    country: null,
    city: '',
    starting_start_timestamp: null,
    starting_end_timestamp: null,
    setup: 0,
    service: 0,
    priority: 0,
    status: '',
    description: ''
};

export const JobsForm = ({
    item,
    close,
    doDelete
}: {
    item?: any;
    close: () => void;
    doDelete?: (item: any) => void;
}) => {
    const { t } = useTranslation() as { t: (key: string) => string };

    const { api, state, options } = useHttpClient();
    const [data, setData] = useState<any | null>(null);
    const [countries, setCountries] = useState<any | null>([]);
    const [startJobDate, setStartJobDate] = useState<any | null>('1');

    const estados = [{ id: "PENDING", name: "PENDING" }, { id: "IN_PROGRESS", name: "IN_PROGRESS" }, { id: "COMPLETED", name: "COMPLETED" }]

    const [startingStartTimestamp, setStartingStartTimestamp] = useState<string>(dayjs().format('YYYY-MM-DDTHH:mm:ss'));
    const [startingEndTimestamp, setStartingEndTimestamp] = useState<string>(dayjs().format('YYYY-MM-DDTHH:mm:ss'));

    useEffect(() => {
        api('/fleet/countries/?limit=9999', 'GET');
    }, []);

    // Load initial data
    useEffect(() => {
        if (item) {
            const modifiedItem = { ...item };

            if (modifiedItem.setup > 0) {
                modifiedItem.setup = modifiedItem.setup / 60;
            }

            if (modifiedItem.service > 0) {
                modifiedItem.service = modifiedItem.service / 60;
            }

            const statusObject = estados.find(e => e.id === modifiedItem.status);
            if (modifiedItem.starting_start_timestamp && (modifiedItem.starting_end_timestamp != modifiedItem.starting_start_timestamp)) {
                setStartJobDate('3')
                setData({ ...modifiedItem, status: statusObject || null });
                setStartingStartTimestamp(modifiedItem.starting_start_timestamp)
                setStartingEndTimestamp(modifiedItem.starting_end_timestamp)
            } else if (modifiedItem.starting_start_timestamp && (modifiedItem.starting_end_timestamp == modifiedItem.starting_start_timestamp)) {
                setStartJobDate('2')
                setData({ ...modifiedItem, status: statusObject || null });
                setStartingStartTimestamp(modifiedItem.starting_start_timestamp)
                setStartingEndTimestamp(modifiedItem.starting_end_timestamp)
            } else {
                setStartJobDate('1')
                setData({ ...modifiedItem, status: statusObject || null });
            }
        }
    }, [item]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;

        setStartingStartTimestamp(value);

    };

    const handleChangeEnd = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;

        setStartingEndTimestamp(value);

    };

    const beforeSubmit = (values: any | null) => {
        const after = { ...values };

        if (after.status && typeof after.status === 'object') {
            after.status = after.status.id;
        }

        if (startJobDate == '2') {
            after.starting_start_timestamp = startingStartTimestamp;
            after.starting_end_timestamp = startingStartTimestamp;
        } else if (startJobDate == '3') {
            after.starting_start_timestamp = startingStartTimestamp;
            after.starting_end_timestamp = startingEndTimestamp;
        } else {
            after.starting_start_timestamp = null;
            after.starting_end_timestamp = null;
        }

        if(+after.setup > 0) {
            after.setup = +after.setup * 60;
        }

        if(+after.service > 0) {
            after.service = +after.service * 60;
        }



        console.log('after', after)

        return after;
    };

    const onSubmit = async (values: any | null) => {
        const enviaremos = beforeSubmit(values);

        if (enviaremos.id) {
            // update

            api(`/fleet/jobs/${enviaremos.id}/`, 'PATCH', enviaremos);
        } else {
            // create

            api('/fleet/jobs/', 'POST', enviaremos);
        }
    };

    // Handle API responses
    useEffect(() => {
        if (state.data) {
            if (state.path.includes('jobs')) {
                if (state.method === 'POST' || state.method === 'PATCH') {
                    toast.success(`${t('common.label.success-saved')}`);
                    close();
                }
            }
            if (state.path.includes('countries')) {
                setCountries(state.data.results);
            }
        }

        if (state.error) {
            if (state.error) {
                if (state.error.non_field_errors[0] == "Could not determine coordinates from address") {
                    toast.error(`${t('common.label.direccion-no-valida')}`);
                }
                if (state.error.non_field_errors[0] == "Error during geocoding. Please check the address and try again.") {
                    toast.error(`${t('common.label.direccion-no-valida')}`);
                }
            }
        }
    }, [state]);

    return (
        <Formik
            initialValues={data || initialValues}
            onSubmit={onSubmit}
            validationSchema={validacion}
            enableReinitialize
        >
            {({
                values,
                errors,
                touched,
                setFieldValue,
                handleSubmit,
                isSubmitting
            }) => (
                <form onSubmit={handleSubmit} autoComplete="off">


                    <Input
                        label={t('common.form-label.address')}
                        type="address"
                        placeholder={t('common.form-label.address')}
                        name="address"
                        value={values.address}
                        onChange={(value) =>
                            setFieldValue('address', value.address)
                        }
                    />
                    <FieldError
                        touched={touched}
                        errors={errors}
                        field={'address'}
                    />

                    <Input
                        label={t('common.form-label.ciudad')}
                        type="text"
                        placeholder={t('common.form-label.ciudad')}
                        name="city"
                        value={values.city}
                        onChange={(value) =>
                            setFieldValue('city', value.city)
                        }
                    />
                    <FieldError
                        touched={touched}
                        errors={errors}
                        field={'city'}
                    />

                    <Select
                        name="country"
                        label={t('common.label.country')}
                        placeholder="Select value"
                        items={countries}
                        value={values.country}
                        onChange={(value) =>
                            setFieldValue('country', value.country)
                        }
                    />
                    <FieldError
                        touched={touched}
                        errors={errors}
                        field={'country'}
                    />
                    {/* <DatePicker
                        name="date"
                        type="date"
                        label={t('common.labels.date')}
                        value={values.date}
                        onChange={(val: any) => setFieldValue('date', val.date ? dayjs(val.date).format('YYYY-MM-DD') : null)}
                    />
                    <FieldError touched={touched} errors={errors} field="date" /> */}

                    <RadioGroup
                        name="startJobDate"
                        label={t("")}
                        layout="horizontal"
                        value={startJobDate}
                        items={[
                            { id: '1', label: t('common.label.sin-horario-inicio') },
                            { id: '2', label: t('common.label.horario-inicio') },
                            { id: '3', label: t('common.label.franja-horaria-inicio') },
                        ]}
                        onChange={(newValue) => {
                            setStartJobDate(newValue.startJobDate);
                        }}
                    />

                    {startJobDate == '2' ? <div className="my-[11px] w-full">
                        {/* --------------------FECHA------------------- */}

                        <label className="block text-sm font-semibold leading-6 text-gray-700">
                            {t('common.label.fecha-horario-inicio-servicio')}
                        </label>
                        <input
                            id="dateInput"
                            type="datetime-local"
                            step="1" // Permite solo minutos (sin segundos)
                            value={startingStartTimestamp} // Mostrar sin segundos en el input
                            onChange={handleChange}
                        />
                    </div> : ''}

                    {startJobDate == '3' ? <div className="my-[11px] w-full">
                        <label className="block text-sm font-semibold leading-6 text-gray-700">
                            {t('common.label.fecha-franja-horaria-inicio-servicio')}
                        </label>
                        <div>
                            <input
                                id="dateInput"
                                type="datetime-local"
                                step="1" // Permite solo minutos (sin segundos)
                                value={startingStartTimestamp} // Mostrar sin segundos en el input
                                onChange={handleChange}
                            />
                        </div>
                        {/* --------------------FECHA------------------- */}
                        <div className='pt-2'>

                            <input
                                id="dateInput"
                                type="datetime-local"
                                step="1" // Permite solo minutos (sin segundos)
                                value={startingEndTimestamp} // Mostrar sin segundos en el input
                                onChange={handleChangeEnd}
                            />
                        </div>

                    </div> : ''}


                    <div>
                        <TextArea
                            label={t(
                                'common.form-label.descripcion'
                            )}
                            placeholder={t(
                                'common.form-label.descripcion'
                            )}
                            name="description"
                            value={values.description}
                            onChange={(value: any) =>
                                setFieldValue(
                                    'description',
                                    value.description
                                )
                            }
                        />
                    </div>

                    <Input
                        label={t('common.label.duracion-configuracion')}
                        type="number"
                        placeholder={t('common.label.duracion-configuracion')}
                        name="setup"
                        value={values.setup}
                        onChange={(value) =>
                            setFieldValue('setup', value.setup)
                        }
                    />

                    <Input
                        label={t('common.label.duracion-servicio')}
                        type="number"
                        placeholder={t('common.label.duracion-servicio')}
                        name="service"
                        value={values.service}
                        onChange={(value) =>
                            setFieldValue('service', value.service)
                        }
                    />

                    <RadioGroup
                        name="priority"
                        label={t("common.label.prioridad")}
                        layout="horizontal"
                        value={values.priority}
                        items={[
                            { id: '0', label: t('common.label.sin-prioridad') },
                            { id: '25', label: t('common.label.baja-prioridad') },
                            { id: '50', label: t('common.label.prioridad-media') },
                            { id: '75', label: t('common.label.alta-prioridad') },
                            { id: '100', label: t('common.label.prioridad-muy-alta') }
                        ]}
                        onChange={(newValue) => setFieldValue('priority', newValue.priority)}
                    />

                    <Select
                        name="status"
                        label={t('common.label.estado')}
                        placeholder="Select value"
                        items={estados}
                        value={data?.status?.id || values.status?.id}
                        onChange={(value) => {
                            setFieldValue('status', value.status)
                        }

                        }
                    />

                    <div className='h-48'></div>


                    <FormFooter
                        item={item}
                        doDelete={doDelete}
                        doSubmit={handleSubmit}
                        close={close}
                    />
                </form>
            )}
        </Formik>
    );
};